<template>
  <div>
    <el-tabs v-model="tabName" @tab-click="handleTabSwitch">
      <el-tab-pane label="买手" name="board"></el-tab-pane>
      <el-tab-pane label="商家运营" name="business-operator"></el-tab-pane>
    </el-tabs>

    <div v-if="tabName == 'board'">
      <board></board>
    </div>
    <div v-if="tabName == 'business-operator'">
      <business-operator></business-operator>
    </div>
  </div>
</template>

<script>
import Board from "./Board";
import BusinessOperator from "./BusinessOperator";

export default {
  components: {
    Board,
    BusinessOperator,
  },
  data() {
    return {
      tabName: "board",
    };
  },
  methods: {
    handleTabSwitch(tab) {
      this.tabName = tab.name;
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/picker/PerformanceBoard.vue